import * as types from '../actionsTypes/recuperoDatiCastellettoActionType';
import new_axios_instance from '../../axios_instance';
import { notifsActions } from "../index";
import {TAB_ENUM_INDIVIDUI_TARGET} from "../../costanti";
import {printOnlyInDevelopment} from "../../fanctionUtility";

export const initCastelletto = () => {
    return {
        type: types.INIT_CASTELLETTO
    }
};

/******************************** Recupera Castelletto intero Periodo ************************************************/

export const getRecuperoCastellettoDaMeseAMese = (param, tab) => async dispatch => {
    sessionStorage.setItem('castellettoLoading', 'true')
    dispatch(setLoading());
    dispatch(initCastelletto());

    let url =
      tab !== "corso"
        ? `/v1/registro/${TAB_ENUM_INDIVIDUI_TARGET[tab].timbratura}/ricerca/corso/${param.idCorso}/${TAB_ENUM_INDIVIDUI_TARGET[tab].timbratura}/${param.idAnagrafica}/daMese/${param.daData}/aMese/${param.aData}`
        : `/v1/corso/registro/${param.idCorso}/daMese/${param.daData}/aMese/${param.aData}`;
    await new_axios_instance.get(url)
        .then(response => {
            sessionStorage.setItem('castellettoLoading', 'false')
            dispatch(getDatiCastellettoPeriodoTotaleSuccess(response.data));
        }).catch(error => {
            sessionStorage.setItem('castellettoLoading', 'false')
            dispatch(notifsActions.notifError('Impossibile recuperare i dati per il castelletto'));
            if ( error.response ) {
                const e = error.response.data;
                if ( typeof e === 'string' || e.startsWith('it') ) {
                    dispatch(getDatiCastellettoPeriodoTotaleFail(e.split(':').splice(1).join('</br>')));
                } else if ( typeof e === 'object' ) {
                    const message = Object.keys(e).map(key => `${key.charAt(0).toUpperCase() + key.slice(1).toLowerCase() } : ${e[key]}`);
                    printOnlyInDevelopment('RECUPERO DATI CASTELLETTO PERIODO TOTALE ::', message);
                    dispatch(getDatiCastellettoPeriodoTotaleFail(message));
                }
            } else {
                dispatch(getDatiCastellettoPeriodoTotaleFail(error.message));
                printOnlyInDevelopment('RECUPERO DATI CASTELLETTO PERIODO TOTALE ::', error.message);
            }
            window.scrollTo({top: 0, behavior: "smooth"});
            document.getElementsByTagName('main')[0].scrollTo({top: 0, behavior: "smooth"})
        });
};

const getDatiCastellettoPeriodoTotaleSuccess = (datiCastelletto) => {
    return {
        type: types.GET_DATI_CASTELLETTO_PERIODO_TOTALE_SUCCESS,
        datiCastellettoPeriodoTotale: datiCastelletto,
        loading: false
    }
};

const getDatiCastellettoPeriodoTotaleFail = (error) => {
    return {
        type: types.GET_DATI_CASTELLETTO_PERIODO_TOTALE_FAIL,
        error: error,
        loading: false
    }
};

/******************************** Recupera Castelletto intero Periodo ************************************************/

/******************************** Recupera Castelletto singolo mese **************************************************/

export const getRecuperoCastellettoMese = (param, tab) => async dispatch => {
    sessionStorage.setItem('castellettoLoading', 'true')
    dispatch(setLoading());
    dispatch(initCastelletto());

    await new_axios_instance.get(`/v1/registro/${TAB_ENUM_INDIVIDUI_TARGET[tab].timbratura}/recupera/corso/${param.idCorso}/${TAB_ENUM_INDIVIDUI_TARGET[tab].timbratura}/${param.idAnagrafica}/mese/${param.daMese}`)
        .then(response => {
            sessionStorage.setItem('castellettoLoading', 'false')
            dispatch(getRecuperoDatiPeriodoSuccess(response.data));
        }).catch(error => {
            sessionStorage.setItem('castellettoLoading', 'false')
            dispatch(notifsActions.notifError('Impossibile recuperare i dati per il castelletto'));
            if ( error.response ) {
                const e = error.response.data;
                if ( typeof e === 'string' || e.startsWith('it') ) {
                    dispatch(getRecuperoDatiPeriodoFail(e.split(':').splice(1).join('</br>')));
                } else if ( typeof e === 'object' ) {
                    const message = Object.keys(e).map(key => `${key.charAt(0).toUpperCase() + key.slice(1).toLowerCase() } : ${e[key]}`);
                    printOnlyInDevelopment('RECUPERO DATI CASTELLETTO PERIODO TOTALE ::', message);
                    dispatch(getRecuperoDatiPeriodoFail(message));
                }
            } else {
                dispatch(getRecuperoDatiPeriodoFail(error.message));
                printOnlyInDevelopment('RECUPERO DATI CASTELLETTO PERIODO TOTALE ::', error.message);
            }
            window.scrollTo({top: 0, behavior: "smooth"});
            document.getElementsByTagName('main')[0].scrollTo({top: 0, behavior: "smooth"})
        });
};

const getRecuperoDatiPeriodoSuccess = (response) => {
    return {
        type: types.GET_DATI_CASTELLETTO_PERIODO_SUCCESS,
        datiCastelletto: response,
        loading: false
    }
};

const getRecuperoDatiPeriodoFail = (error) => {
    return {
        type: types.GET_DATI_CASTELLETTO_PERIODO_FAIL,
        error: error,
        loading: false
    }
};

/******************************** Recupera Castelletto singolo mese **************************************************/


const setLoading = () => {
    return {
        type: types.SET_LOADING,
        loading: true
    }
};
